module.exports = __webpack_public_path__ + "img/logo_T-red.dda0b777.svg";